
<ng-container *ngIf="isLoaded">
  <div style="text-align: right; font-size: 17px; margin-right: 20px; margin-top: 5px; font-weight: 600 " (click)="closeModal()">X</div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Създаване на Тип на Документа</h5>
        <p class="text-center small">Моля, въведете основните данни на Посредника</p>
      </div>

      <form [formGroup]="Form" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
        <div class="col-12">
          <label for="title" class="form-label">Име</label>
          <input type="text" formControlName="title" class="form-control" id="title">
        </div>
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="isActive" id="isActive">
            <label class="form-check-label" for="isActive">Активен</label>
          </div>
        </div>
        <div class="col-12">
          <button class="btn btn-primary w-100" type="submit" [disabled]="!Form.valid">Създай</button>
        </div>
      </form>
    </div>
  </div>

</ng-container>
